import type * as PdfjsModule from "pdfjs-dist";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

export type Pdfjs = typeof PdfjsModule;

/**
 * Lazy-load pdf.js and point it at its worker.
 *
 * The dynamic `import()` lets Vite code-split the library out of each SPA's
 * initial bundle, so only routes that mount a `DocumentViewer` load it. The
 * worker is a same-origin `?url` asset, which the CSP's `script-src 'self'`
 * allows.
 *
 * This is also the seam the DocumentViewer test mocks
 * (`@dearbill/shared/lib/pdfjs`). jsdom has no canvas 2D context or Worker, so
 * the real renderer must never run there. `pdfjs-dist` resolves only from this
 * package, so a consumer package's `vi.mock("pdfjs-dist")` can't intercept it.
 */
export async function loadPdfjs(): Promise<Pdfjs> {
  const pdfjs = await import("pdfjs-dist");
  pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
  return pdfjs;
}
